import { CreditCard, Landmark, PiggyBank, Store, Wallet, type LucideIcon } from 'lucide-react'
import type { AccountType } from './types'

export const ACCOUNT_ICON: Record<AccountType, LucideIcon> = { cash: Wallet, bank: Landmark, pos: Store, credit_card: CreditCard, deposit: PiggyBank }

/** Kategori renk sırası `--chart-1..5` token'larından gelir (açık/koyu tema uyumlu). */
export const chartColor = (n: number) => `var(--chart-${((n - 1) % 5) + 1})`

/** Gelir/gider serileri: gelir yeşil (chart-3), gider kırmızı (chart-5); lejant ve etiketle birlikte kullanılır. */
export const SERIES = { income: 'var(--chart-3)', expense: 'var(--chart-5)', primary: 'var(--chart-1)', secondary: 'var(--chart-2)', tertiary: 'var(--chart-4)' } as const

export const TOOLTIP_STYLE = { background: 'var(--popover)', border: '1px solid var(--border)', borderRadius: 8, fontSize: 12, color: 'var(--popover-foreground)' }
export const AXIS_TICK = { fontSize: 11, fill: 'var(--muted-foreground)' }

/** Grafik ekseni için kısa TL biçimi (yalnız görüntüleme; hesap yapılmaz). */
export const axisMoney = (v: number) => new Intl.NumberFormat('tr-TR', { notation: 'compact', maximumFractionDigits: 1 }).format(v)
